import HeypsterPopup from './HeypsterPopup.js';

const _apiKey = new WeakMap();

export default class HeypsterGifSDK {

    constructor(apiKey, initialize = false, language = 'fr', position = 'top', appearance = 'v1') {
        this.language = language;
        this.position = position;
        this.appearance = appearance;
        if (!apiKey) {
            throw new Error('API key is required.');
        }
        _apiKey.set(this, apiKey);
        if(initialize){
            return this.initialize();
        }
    }

    // Initialisation du SDK
    initialize() {
        const popupBuilder = new HeypsterPopup(this.getApiKey(), this.language, this.position, this.appearance);
        return popupBuilder;
    }

    getApiKey(){
        return _apiKey.get(this);
    }


}
